import React, { useEffect, useState } from "react";
import {
  Card, Typography, Table, TableHead, TableRow, TableCell,
  TableBody, CircularProgress, Box, TextField, Button, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Chip, Paper, InputAdornment
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";

const ApplicationList = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openEdit, setOpenEdit] = useState(false);
  const [currentApp, setCurrentApp] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const [searchName, setSearchName] = useState("");
  const [searchMobile, setSearchMobile] = useState("");
  const [searchAadhar, setSearchAadhar] = useState("");

  const navigate = useNavigate();

  const handleLogout = () => {
  localStorage.removeItem("auth");
  navigate("/login");
};
  // ✅ FETCH FROM SUPABASE
  const fetchApplications = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("applications")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error(error);
      alert("Fetch failed");
    } else {
      setApplications(data);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleOpenEdit = (app) => {
    setCurrentApp({ ...app });
    setOpenEdit(true);
  };

  // ✅ UPDATE
  const handleUpdate = async () => {
    setIsUpdating(true);

    const { error } = await supabase
      .from("applications")
      .update({
        name: currentApp.name,
        mobile: currentApp.mobile,
        amount: currentApp.amount,
        purchase_type: currentApp.purchase_type
      })
      .eq("id", currentApp.id);

    if (error) {
      alert(error.message);
    } else {
      fetchApplications();
      setOpenEdit(false);
      alert("Updated successfully");
    }

    setIsUpdating(false);
  };

  // ✅ DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record permanently?")) return;

    const { error } = await supabase
      .from("applications")
      .delete()
      .eq("id", id);

    if (error) {
      alert(error.message);
    } else {
      setApplications(applications.filter(a => a.id !== id));
    }
  };

  const filteredApplications = applications.filter(app =>
    (app.name || "").toLowerCase().includes(searchName.toLowerCase()) &&
    (app.mobile || "").includes(searchMobile) &&
    (app.aadhar || "").includes(searchAadhar)
  );

  if (loading)
    return <Box sx={{ textAlign: "center", py: 4 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
        Gmobiles Customers Management
        {/* <Button variant="outlined" onClick={handleLogout}>
          Logout
          </Button> */}
      </Typography>

      {/* SEARCH */}
      <Paper sx={{ p: 2, mb: 3, display: "flex", gap: 2 }}>
        <TextField
          placeholder="Search by name..."
          size="small"
          InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>) }}
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
        <TextField
          placeholder="Search by mobile..."
          size="small"
          value={searchMobile}
          onChange={(e) => setSearchMobile(e.target.value)}
        />
        <TextField
          placeholder="Search by Aadhar..."
          size="small"
          value={searchAadhar}
          onChange={(e) => setSearchAadhar(e.target.value)}
        />
      </Paper>

      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredApplications.map(app => (
              <TableRow key={app.id}>
                <TableCell>{app.name}</TableCell>
                <TableCell>{app.mobile}</TableCell>
                <TableCell>
                  <Chip label={app.purchase_type || "N/A"} size="small" />
                </TableCell>
                <TableCell>₹{app.amount}</TableCell>

                <TableCell>
                  {[1,2,3,4,5].map(num => {
                    const url = app[`file${num}`];
                    if (!url) return null;
                    return (
                      <Button key={num} href={url} target="_blank" size="small">
                        File {num}
                      </Button>
                    );
                  })}

                  {/* WhatsApp */}
                  <IconButton
                    color="success"
                    onClick={() => {
                      const links = [app.file1, app.file2, app.file3, app.file4, app.file5]
                        .filter(Boolean)
                        .join("\n");

                      const msg = encodeURIComponent(
                        `Hello, your application files:\n${links}`
                      );

                      window.open(`https://wa.me/919791615143?text=${msg}`);
                    }}
                  >
                    <WhatsAppIcon />
                  </IconButton>

                  {/* <IconButton color="info" onClick={() => handleOpenEdit(app)}>
                    <EditIcon />
                  </IconButton> */}
                  <IconButton color="info" onClick={() => navigate(`/edit-application/${app.id}`)}>
                    <EditIcon />
                    </IconButton>

                  <IconButton color="error" onClick={() => handleDelete(app.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      {/* EDIT DIALOG */}
      {/* <Dialog open={openEdit} onClose={() => setOpenEdit(false)}>
        <DialogTitle>Edit Application</DialogTitle>

        <DialogContent>
          {currentApp && (
            <>
              <TextField fullWidth label="Name"
                value={currentApp.name}
                onChange={(e) => setCurrentApp({...currentApp, name: e.target.value})}
                sx={{ mt:2 }}
              />

              <TextField fullWidth label="Mobile"
                value={currentApp.mobile}
                onChange={(e) => setCurrentApp({...currentApp, mobile: e.target.value})}
                sx={{ mt:2 }}
              />

              <TextField fullWidth label="Amount"
                value={currentApp.amount}
                onChange={(e) => setCurrentApp({...currentApp, amount: e.target.value})}
                sx={{ mt:2 }}
              />
            </>
          )}
        </DialogContent> */}

        {/* <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button onClick={handleUpdate} startIcon={<SaveIcon />}>
            Save
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default ApplicationList;
